import { SVGProps } from "react";

/**
 * Figma `user-multiple-02` icon (0 0 21.5 19.5), duotone - fill follows
 * currentColor so the caller can tint it per selection state.
 */
const UserMultiple02 = ({
  width = 21.5,
  height = 19.5,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21.5 19.5"
    fill="none"
    {...props}
  >
    <g id="elements">
      <path
        id="Tone"
        opacity="0.4"
        d="M9.75 11.75C12.5114 11.75 14.75 13.9886 14.75 16.75C14.75 17.8546 13.8546 18.75 12.75 18.75H2.75C1.64543 18.75 0.75 17.8546 0.75 16.75C0.75 13.9886 2.98858 11.75 5.75 11.75H9.75ZM7.75 0.75C9.95914 0.75 11.75 2.54086 11.75 4.75C11.75 6.95914 9.95914 8.75 7.75 8.75C5.54086 8.75 3.75 6.95914 3.75 4.75C3.75 2.54086 5.54086 0.75 7.75 0.75Z"
        fill="currentColor"
      />
      <path
        id="Icon"
        d="M9.75 11C12.9256 11 15.5 13.5744 15.5 16.75C15.5 18.2688 14.2688 19.5 12.75 19.5H2.75C1.23122 19.5 0 18.2688 0 16.75C0 13.5744 2.57436 11 5.75 11H9.75ZM15.75 11C18.9256 11 21.5 13.5744 21.5 16.75C21.5 18.2688 20.2688 19.5 18.75 19.5H17.25C16.8358 19.5 16.5 19.1642 16.5 18.75C16.5 18.3358 16.8358 18 17.25 18H18.75C19.4404 18 20 17.4404 20 16.75C20 14.4028 18.0972 12.5 15.75 12.5C15.3358 12.5 15 12.1642 15 11.75C15 11.3358 15.3358 11 15.75 11ZM5.75 12.5C3.40279 12.5 1.5 14.4028 1.5 16.75C1.5 17.4404 2.05964 18 2.75 18H12.75C13.4404 18 14 17.4404 14 16.75C14 14.4028 12.0972 12.5 9.75 12.5H5.75ZM7.75 0C10.3734 0 12.5 2.12665 12.5 4.75C12.5 7.37335 10.3734 9.5 7.75 9.5C5.12665 9.5 3 7.37335 3 4.75C3 2.12665 5.12665 0 7.75 0ZM13.75 0C16.3734 0 18.5 2.12665 18.5 4.75C18.5 7.37335 16.3734 9.5 13.75 9.5C13.3358 9.5 13 9.16421 13 8.75C13 8.33579 13.3358 8 13.75 8C15.5449 8 17 6.54493 17 4.75C17 2.95507 15.5449 1.5 13.75 1.5C13.3358 1.5 13 1.16421 13 0.75C13 0.335786 13.3358 0 13.75 0ZM7.75 1.5C5.95507 1.5 4.5 2.95507 4.5 4.75C4.5 6.54493 5.95507 8 7.75 8C9.54493 8 11 6.54493 11 4.75C11 2.95507 9.54493 1.5 7.75 1.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default UserMultiple02;
